<template>
  <div class="componente-encantado" ref="containerRef">

    <!-- 🌿 RAMAS -->
    <img src="@/assets/ramas.png" class="rama rama-izq" ref="ramaIzq" />
    <img src="@/assets/ramas.png" class="rama rama-der" ref="ramaDer" />

    <!-- 🌸 FLORES -->
    <img src="@/assets/f.png" class="flor flor-1" ref="flor1" />
    <img src="@/assets/f.png" class="flor flor-2" ref="flor2" />
    <img src="@/assets/f.png" class="flor flor-3" ref="flor3" />

    <!-- 🦋 MARIPOSAS -->
    <img src="@/assets/mariposas.png" class="mariposa m1" ref="m1" />
    <img src="@/assets/mariposas.png" class="mariposa m2" ref="m2" />
    <img src="@/assets/mariposas.png" class="mariposa m3" ref="m3" />

    <!-- 📸 FOTO -->
    <img
      src="@/assets/EEE3701EE_11zon.webp"
      class="foto-magica"
      ref="fotoRef"
    />

    <!-- 🔽 RASGADO INFERIOR -->
    <div class="rasgado rasgado-inferior"></div>

  </div>
</template>
<script>
import { ref, onMounted, nextTick } from 'vue'
import gsap from 'gsap'

export default {
  name: 'CuentoEncantado',
  setup() {
    const containerRef = ref(null)
    const fotoRef = ref(null)

    const ramaIzq = ref(null)
    const ramaDer = ref(null)

    const flor1 = ref(null)
    const flor2 = ref(null)
    const flor3 = ref(null)

    const m1 = ref(null)
    const m2 = ref(null)
    const m3 = ref(null)

    onMounted(async () => {
      await nextTick()

      gsap.set(
        [
          fotoRef.value,
          ramaIzq.value,
          ramaDer.value,
          flor1.value,
          flor2.value,
          flor3.value,
          m1.value,
          m2.value,
          m3.value
        ],
        { autoAlpha: 0 }
      )

      gsap.set([ramaIzq.value, ramaDer.value], {
        scaleY: 0,
        transformOrigin: 'top center',
        filter: 'blur(3px)'
      })

      gsap.set([m1.value, m2.value, m3.value], {
        y: 40,
        scale: 0.6,
        filter: 'blur(2px)'
      })

      const io = new IntersectionObserver(([entry]) => {
        if (!entry.isIntersecting) return

        const tl = gsap.timeline({ defaults: { ease: 'power2.out' } })

        tl.fromTo(
          fotoRef.value,
          { autoAlpha: 0, scale: 0.85, y: 60 },
          {
            autoAlpha: 1,
            scale: 1,
            y: 0,
            duration: 1.1,
            ease: 'back.out(1.6)'
          }
        )

        tl.to(
          [ramaIzq.value, ramaDer.value],
          {
            autoAlpha: 1,
            scaleY: 1,
            filter: 'blur(0px)',
            duration: 0.8,
            stagger: 0.15
          },
          '-=0.6'
        )

        tl.to(
          [flor1.value, flor2.value, flor3.value],
          {
            autoAlpha: 1,
            y: 0,
            duration: 0.7,
            stagger: 0.12
          },
          '-=0.5'
        )

        tl.to(
          [m1.value, m2.value, m3.value],
          {
            autoAlpha: 1,
            y: 0,
            scale: 1,
            filter: 'blur(0px)',
            duration: 0.6,
            stagger: 0.12
          },
          '-=0.6'
        )

        gsap.to([flor1.value, flor2.value, flor3.value], {
          y: '+=10',
          duration: 3.5,
          yoyo: true,
          repeat: -1,
          ease: 'sine.inOut'
        })

        gsap.to([m1.value, m2.value, m3.value], {
          y: '+=12',
          duration: 2.8,
          yoyo: true,
          repeat: -1,
          ease: 'sine.inOut'
        })

        gsap.to([ramaIzq.value, ramaDer.value], {
          y: '+=14',
          duration: 4,
          yoyo: true,
          repeat: -1,
          ease: 'sine.inOut'
        })

        io.disconnect()
      }, { threshold: 0.4 })

      io.observe(containerRef.value)
    })

    return {
      containerRef,
      fotoRef,
      ramaIzq,
      ramaDer,
      flor1,
      flor2,
      flor3,
      m1,
      m2,
      m3
    }
  }
}
</script>

<style scoped>
.componente-encantado {
  position: relative;
  width: 100%;
  min-height: 80vh;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: visible;
}

/* FOTO */
.foto-magica {
  width: min(90vw, 420px);
  border-radius: 12px;
  box-shadow: 0 20px 50px rgba(0,0,0,.35);
  z-index: 3;
}

/* RAMAS */
.rama {
  position: absolute;
  width: min(30vw, 180px);
  opacity: 0.45;
  z-index: 1;
  pointer-events: none;
}
.rama-izq {
  left: -40px;
  top: 80px;
}
.rama-der {
  right: -60px;
  top: 120px;
}

/* FLORES */
.flor {
  position: absolute;
  width: 0px;
  opacity: 0;
  z-index: 2;
}
.flor-1 { top: 10%; left: 62%; }
.flor-2 { top: 18%; right: 54%; }
.flor-3 { bottom: 10%; left: 20%; }

/* MARIPOSAS */
.mariposa {
  position: absolute;
  width: min(14vw, 90px);
  opacity: 0.6;
  z-index: 4;
}
.m1 { top: 6%; right: 30%; }
.m2 { top: 16%; left: 28%; }
.m3 { bottom: 14%; right: 24%; }

/* 🔽 RASGADO */
.rasgado {
  position: absolute;
  left: 0;
  width: 100%;
  height: 60px;
  pointer-events: none;
  z-index: 5;
}

.rasgado-inferior {
  bottom: 0;
  clip-path: polygon(
    0% 20%, 25% 40%, 50% 15%, 75% 45%, 100% 25%,
    100% 100%, 0% 100%
  );
}
</style>
